// Shared column geometry for the Sale Deposit Report table. The header, the body and the
// totals footer all render inside ONE <Table>, so they must pin the same columns at the same
// offsets — keeping the numbers here is what stops the three from drifting apart.

/** วันที่ + สายส่ง are pinned left because the money columns push the table wider than the
 * viewport; without the pin a horizontally scrolled row cannot be tied back to its route. */
export const DATE_COLUMN_WIDTH = 104;

/**
 * The row-selection checkbox column, pinned ahead of วันที่ for the reviewers who get it.
 * Its width shifts the two pinned columns along, which is why it lives here with them.
 */
export const SELECT_COLUMN_WIDTH = 52;

/** A pinned header cell must sit above both the pinned body cells and the scrolling header. */
export const STICKY_HEADER_Z_INDEX = 3;
export const STICKY_BODY_Z_INDEX = 1;

export const stickyColumnSx = (left: number, zIndex: number) => ({
  position: "sticky" as const,
  left,
  zIndex,
  bgcolor: "inherit",
});
